import { api } from './client';
import type { PaginatedResponse, ReverseRequest } from '@/types/domain';

export interface ReverseListParams {
  category?: string;
  city?: string;
  cursor?: string | null;
  /** F-170 B2.7: ask the backend to scope the list to the authenticated
   *  client's own requests. Best-effort — if the API ignores the flag,
   *  the page should still gate at render time. */
  mine?: boolean;
}

export async function fetchReverseList(
  params: ReverseListParams = {},
): Promise<PaginatedResponse<ReverseRequest>> {
  return api.get('/reverse-requests/', {
    query: {
      category: params.category,
      city: params.city,
      cursor: params.cursor ?? undefined,
      mine: params.mine ? '1' : undefined,
    },
  });
}

export async function fetchReverseRequest(id: number): Promise<ReverseRequest> {
  return api.get(`/reverse-requests/${id}/`);
}

export interface ReverseCreateInput {
  category_slug: string;
  city_slug: string;
  description: string;
  budget_eur_max?: number;
  desired_date?: string;
  is_anonymous?: boolean;
}

export async function createReverseRequest(
  input: ReverseCreateInput,
): Promise<{ status: 'live' | 'moderated_out'; id: number; moderation_note?: string }> {
  return api.post('/reverse-requests/', { body: input });
}

export async function respondReverseRequest(id: number, text: string): Promise<void> {
  await api.post(`/reverse-requests/${id}/respond/`, { body: { text } });
}

export async function closeReverseRequest(id: number): Promise<void> {
  await api.post(`/reverse-requests/${id}/close/`);
}

export async function flagReverseRequest(id: number, reason: string): Promise<void> {
  await api.post(`/reverse-requests/${id}/flag/`, { body: { reason } });
}
